import type { SVGProps } from 'react'
const SvgCart = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="1em" viewBox="0 0 41 40" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <ellipse cx={20.768} cy={20} fill="#DC4405" rx={20.232} ry={20} />
    <g clipPath="url(#cart_svg__a)">
      <path
        d="M11.146 12.912c0-.419.338-.773.81-.773h1.521c.743 0 1.419.419 1.723 1.03h13.885c.879 0 1.52.805 1.284 1.643l-1.385 4.893c-.27 1.03-1.25 1.707-2.331 1.707h-9.764l.203.934c.068.354.405.611.777.611h9.764c.439 0 .81.354.81.773 0 .45-.371.773-.81.773h-9.764c-1.149 0-2.162-.773-2.365-1.868l-1.757-8.725c-.033-.129-.135-.225-.27-.225h-1.52c-.473 0-.811-.322-.811-.773m4.324 14.166c0-.547.304-1.03.811-1.32.473-.29 1.115-.29 1.622 0 .473.29.81.773.81 1.32 0 .58-.337 1.063-.81 1.353-.507.29-1.149.29-1.622 0-.507-.29-.81-.773-.81-1.353m11.352-1.545c.574 0 1.08.322 1.385.773.304.483.304 1.095 0 1.545a1.62 1.62 0 0 1-1.385.773c-.608 0-1.115-.29-1.42-.773-.303-.45-.303-1.062 0-1.545.305-.45.812-.773 1.42-.773"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="cart_svg__a">
        <path d="M11 12h20v17H11z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgCart
